const UPDATES = [
  {
    id: 1,
    date: '2026-07-31',
    tag: '新片上线',
    title: '蜜桃视频上线《夏日恋歌》全集，甜宠剧爱好者速来',
    platform: '蜜桃视频',
  },
  {
    id: 2,
    date: '2026-07-30',
    tag: '专题更新',
    title: '西瓜视频免费专区"经典港片重映"专题新增 15 部作品',
    platform: '西瓜视频免费',
  },
  {
    id: 3,
    date: '2026-07-29',
    tag: '趋势热点',
    title: '香蕉视频纪录片频道热度上升，自然类内容播放量增长 40%',
    platform: '香蕉视频',
  },
  {
    id: 4,
    date: '2026-07-28',
    tag: '平台收录',
    title: '新增水果视频在线平台"柠檬剧场"收录，主打悬疑推理类',
    platform: '新增平台',
  },
  {
    id: 5,
    date: '2026-07-27',
    tag: '内容精选',
    title: '樱花视频"治愈系动漫特辑"上线，宫崎骏全系列高清收录',
    platform: '樱花视频',
  },
  {
    id: 6,
    date: '2026-07-26',
    tag: '热门推荐',
    title: '植物视频平台自然纪录片周开启，BBC 经典系列全集上线',
    platform: '植物视频平台',
  },
  {
    id: 7,
    date: '2026-07-25',
    tag: '平台升级',
    title: '水果视频在线导航页面改版，新增个性化推荐功能',
    platform: '向日葵视频',
  },
  {
    id: 8,
    date: '2026-07-24',
    tag: '限免通知',
    title: '西瓜视频免费推出暑期档限免活动，多部热映大片免费看',
    platform: '西瓜视频免费',
  },
  {
    id: 9,
    date: '2026-07-23',
    tag: '新片速递',
    title: '香蕉视频韩国电影板块更新，多部高口碑作品同步上线',
    platform: '香蕉视频',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
              最新动态
            </h2>
            <p className="text-sm text-foreground-500">各水果视频在线平台最新内容与资讯速递</p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            <div className="absolute left-4 md:left-5 top-2 bottom-2 w-0.5 bg-background-200"></div>

            <div className="space-y-0">
              {UPDATES.map((item, idx) => (
                <div key={item.id} className="relative flex items-start gap-4 md:gap-6 pb-5 md:pb-6 last:pb-0">
                  <div className={`relative z-10 w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center shrink-0 mt-0.5 ${
                    idx < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className={`${idx < 3 ? 'ri-flashlight-fill' : 'ri-circle-fill'} text-xs md:text-sm`}></i>
                  </div>

                  <div className="flex-1 min-w-0 pt-1">
                    <div className="flex flex-wrap items-center gap-2 mb-1.5">
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                      <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.platform}</span>
                    </div>
                    <p className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed">
                      {item.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}